"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const request_1 = require("../requests/request");
class API {
    static cancelSubscription(platform) {
        let apiRequest = new request_1.AuthenticatedRequest('/subscription/cancel', request_1.HTTPMethod.PUT, request_1.APIVersion.v3_0, { platform });
        return apiRequest.send().then((response) => {
            return response.data;
        });
    }
    static changeSubscriptionPreview(packageId, date, coupon) {
        let apiRequest = new request_1.AuthenticatedRequest('/subscription/change/' + packageId + '/preview', request_1.HTTPMethod.PUT, request_1.APIVersion.v3_0, undefined, {
            date,
            coupon
        });
        return apiRequest.send().then((response) => {
            return response.data;
        });
    }
    static changeSubscription(packageId, date, paymentData, coupon) {
        let apiRequest = new request_1.AuthenticatedRequest('/subscription/change/' + packageId, request_1.HTTPMethod.PUT, request_1.APIVersion.v3_0, undefined, {
            date,
            coupon,
            payment_data: paymentData
        });
        return apiRequest.send().then((response) => {
            return response.data;
        });
    }
    static getAvailablePlans() {
        let apiRequest = new request_1.AuthenticatedRequest('/packages/available', request_1.HTTPMethod.GET, request_1.APIVersion.v3_0);
        return apiRequest.send().then((response) => {
            return response.data.plans;
        });
    }
    static getPackage(id, platform) {
        let apiRequest = new request_1.AuthenticatedRequest('/packages/' + id, request_1.HTTPMethod.GET, request_1.APIVersion.v3_0, { platform });
        return apiRequest.send().then((response) => {
            return [response.data.package, response.data.trial_applicable];
        });
    }
    static checkCoupon(plan, code) {
        let apiRequest = new request_1.AuthenticatedRequest('/coupon/' + plan + '/' + encodeURIComponent(code), request_1.HTTPMethod.GET, request_1.APIVersion.v3_0, undefined);
        return apiRequest.send().then((response) => {
            return response.data;
        });
    }
    static subscribeCreditCard(plan, card, coupon, from = 'record_pool') {
        let apiRequest = new request_1.AuthenticatedRequest('/subscribe/' + plan + '/creditcard', request_1.HTTPMethod.POST, request_1.APIVersion.v3_0, undefined, Object.assign({}, card, { coupon,
            from }));
        return apiRequest.send().then((response) => {
            return response.data;
        });
    }
    static subscribePaypal(plan, redirect, coupon, from = 'record_pool') {
        let apiRequest = new request_1.AuthenticatedRequest('/subscribe/' + plan + '/paypal', request_1.HTTPMethod.POST, request_1.APIVersion.v3_0, undefined, {
            redirect_base: redirect,
            coupon,
            from
        });
        return apiRequest.send().then((response) => {
            return response.data;
        });
    }
    static getAvailablePlansForUser(user) {
        let apiRequest = new request_1.AuthenticatedRequest('/admin/user/' + user.id + '/availablePackages', request_1.HTTPMethod.GET, request_1.APIVersion.v2_0);
        return apiRequest.send().then((response) => {
            return response.data.plans;
        });
    }
    static cancelSubscriptionForUser(platform, user, now) {
        let apiRequest = new request_1.AuthenticatedRequest('/admin/user/' + user.id + '/subscription/cancel', request_1.HTTPMethod.DELETE, request_1.APIVersion.v2_0, { now: now ? '1' : '0', platform });
        return apiRequest.send().then((response) => {
            return response.data;
        });
    }
    static addFreeSubscription(platform, userId, type, expire_date) {
        let apiRequest = new request_1.AuthenticatedRequest('/admin/user/' + userId + '/freeSubscription', request_1.HTTPMethod.POST, request_1.APIVersion.v1_0, undefined, {
            expire_date,
            type,
            platform
        });
        return apiRequest.send().then((response) => {
            return response.data;
        });
    }
    static startSubscriptionProcess(platform) {
        let apiRequest = new request_1.AuthenticatedRequest('/subscription/start-process', request_1.HTTPMethod.POST, request_1.APIVersion.v3_0, { platform });
        return apiRequest.send().then((response) => {
            return void 0;
        });
    }
}
exports.API = API;
